import React, { useContext } from "react";
import { css } from "emotion";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import MenuItem from "./MenuItem";
import LogoutButton from "./LogoutButton";
import { GlobalContext } from "../../context/GlobalState";

const Menu = () => {
  const { userData, currentWorkspace } = useContext(GlobalContext);

  const isAdmin = userData.isAdmin || (userData.hasOwnProperty('roles') && userData.roles.hasOwnProperty(currentWorkspace.id) && userData.roles[currentWorkspace.id].role === 'admin');

  return (
    <div className={container}>
      <p className="header">MENU</p>
      <MenuItem route="home" />
      <MenuItem route="embed" />
      {isAdmin && <MenuItem route="plans" />}
      <MenuItem route="settings" />
    </div>
  );
};

export default Menu;

const container = css`
  padding: ${boxStyles.desktopPadding};
  .header {
    color: ${colors.placeholderText};
    font-weight: bold;
    padding: ${boxStyles.standardPadding} 0;
    font-size: ${textSizes.normal};
  }
`;
